import React from 'react';
import { Stethoscope, Phone, Activity, FileText, Users, Scale } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from './ui/card';
import { services } from '../data/mock';

const Services = () => {
  const iconMap = {
    Stethoscope,
    Phone,
    Activity,
    FileText,
    Users,
    Scale
  };

  return (
    <section id="servicios" className="py-24 bg-gradient-to-b from-white via-[#7DAAAF]/12 to-white relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#7DAAAF]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#3D2418]/5 rounded-full blur-3xl"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-16 animate-in">
          <div className="inline-block mb-4">
            <span className="text-[#7DAAAF] font-semibold text-sm tracking-wider uppercase">Atención médica integral</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#3D2418] mb-6 uppercase tracking-tight">
            Servicios
          </h2>
          <div className="w-32 h-1.5 bg-gradient-to-r from-[#7DAAAF] to-[#3D2418] rounded-full mx-auto"></div>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const Icon = iconMap[service.icon];
            return (
              <Card 
                key={service.id}
                className="border-2 border-gray-100 shadow-md bg-white rounded-2xl overflow-hidden"
              >
                <CardHeader className="pb-4">
                  <div className="w-16 h-16 bg-gradient-to-br from-[#7DAAAF] to-[#6a959a] rounded-2xl flex items-center justify-center mb-4 shadow-lg">
                    <Icon className="w-8 h-8 text-white" />
                  </div>
                  <CardTitle className="text-xl font-bold text-[#3D2418]">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-gray-600 text-base leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
